<template>
    <div class="compteAutoComplete">

         <!--Champs d'entrer pour le compte-->
        <b-form-input 
            id="compte"
            name="accountNumber"
            class="txtPrincipal" 
            :state="validateAccountState()"
            type="text" 
            maxlength="15"
            autocomplete="off" 
            v-model="displayValue"
            @keyup="validateAccount()"
            @click="openMenu=true">
        </b-form-input>
        <!-- FIN - Champs d'entrer pour le compte-->
        
        <!--AUTOCOMPLETION - SELECTION DE TOUS LES COMPTES-->
        <div class="colomnSelectionMenu" v-show="openMenu">
            
            <b-row style="margin-bottom: 5px;">
                <!--Bouton fermer-->
                <b-col cols="6">
                    <b-button :variant="getTheme.warning" style="width: 80%;" @click="openMenu=false">{{$t("g_Fermer")}}</b-button>
                </b-col>
                <!--Bouton effacer-->
                <b-col cols="6" align="right">
                    <b-button :variant="getTheme.danger" style="width: 80%;" @click="updateVModel('')">{{$t("g_Efface")}}</b-button>
                </b-col>
            </b-row>
    
<!--***************************************************************************************************-->

            <div class="scrollIn">
                <!--{{vmodel}}-->
                <!--List des items de l'autoCompletion-->
                <b-list-group style="margin-top: 5px">
                    <b-list-group-item 
                        class="cursorPoint btnStyle btnFirstLetter"
                        v-for="(account) in rechercheAutoComplete" 
                        :key="account.index" 
                        @click="selectAccount(account.number)">

                            <b-row>
                                <b-col cols="3">
                                    <span>
                                        {{account.number}}
                                    </span>
                                </b-col>
                                <b-col cols="9">
                                    <span>
                                        {{account.description0}}
                                    </span>
                                </b-col>
                            </b-row>

                    </b-list-group-item>
                </b-list-group>
            </div>

<!--***************************************************************************************************-->
        </div>
        <!--FIN - AUTOCOMPLETION - SELECTION DE TOUS LES COMPTES-->

<!--{{vmodel}}<br><br>
{{this.inscriptionLine}}-->

    </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default{
    name: "compteAutoComplete",
    props: ['vmodel'],
    data() {
        return {
            openMenu: false,
            accountSearch:{
                accountIndex: 0,
                searchValue: ''
            },
            inscriptionLine:{
                    compte: '',
                    description: '',
                    debit: 0,
                    credit: 0,
                    projet: '',
                    delete: false,
                    openMenu: false,
                    openBank: false
                },
        }
    },
    methods: {
        updateVModel(sendValue){
            this.displayValue = sendValue
            //this.$emit('update:vmodel', sendValue)
        },
        selectAccount(accountNumber){

            var fromAPIAccountId = this.getFromApiAccountIndexFromNumber(accountNumber)

            this.inscriptionLine.description = this.getCompteGL[fromAPIAccountId].description0
            this.vmodel = this.getCompteGL[fromAPIAccountId].number
            this.updateVModel(this.getCompteGL[fromAPIAccountId].number)

            this.openMenu = false

        },
        validateAccountState(){
            //utiliser pour la state de la zone de texte
            if(this.getCompteGL)
            {
                var accountExist = false
                var i = 0
                for (i = 0; i < this.getCompteGL.length; i++)
                    {
                        if (this.getCompteGL[i].number == this.displayValue)
                        {
                            accountExist = true
                        }
                    }

                if(accountExist == true)
                    {
                        return true
                    }
                else
                    {
                        return false
                    }
            }
            else
            {return false}
        },
        validateAccount(){

            if (this.getCompteGL)
            {
                // eslint-disable-next-line no-unused-vars
                var fromAPIAccountId = 0

                var accountExist = false
                var i = 0
                for (i = 0; i < this.getCompteGL.length; i++)
                    {
                        if (this.getCompteGL[i].number == this.vmodel)
                        {
                            fromAPIAccountId = this.getFromApiAccountIndexFromNumber(this.getCompteGL[i].number)
                            accountExist = true
                        }
                    }

                if(this.vmodel.length > 0 && accountExist == true)
                    {
                        //this.inscriptionLine[this.accountSearch.accountIndex].description = this.getCompteGL[fromAPIAccountId].description0
                        
                        this.openMenu = false
                        
                    }
                else
                    {
                        //this.inscriptionLine[this.accountSearch.accountIndex].description = ''
                        
                        this.openMenu = true
                        
                    }
            }

        },
        getFromApiAccountIndexFromNumber(accountNumber){
            if (this.getCompteGL)
            {
                var fromAPIAccountId = ''
                var i = 0 

                for (i = 0; i < this.getCompteGL.length; i++)
                {
                    if (this.getCompteGL[i].number == accountNumber)
                    {
                        fromAPIAccountId = i
                    }
                }

                return fromAPIAccountId
            }
            else
            {return 0}
        },

    },
    computed: {
        ...mapGetters(['getTheme', 'getCompteGL']),
        displayValue: {
            get: function() 
                    {
                        let sendValue = this.vmodel;
                        if(sendValue == 0){sendValue = ''}
                        return sendValue
                        //return this.vmodel
                    },
            set: function(modifiedValue)
                    {
                        //this.inscriptionLine.compte = modifiedValue
                        //this.vmodel = modifiedValue
                        //this.$emit('update:vmodel', this.vmodel)
                        this.$emit('update:vmodel', modifiedValue)
                    }
        },
        rechercheAutoComplete() {
            if(this.getCompteGL)
            {
                //const search = this.vmodel //.toLowerCase().trim();
                const search = this.vmodel;
                if (!search) return this.getCompteGL.filter(c => c.isActive == true);

                return this.getCompteGL.filter(c => c.description0.toLowerCase().indexOf(search) > -1 || c.number.toLowerCase().indexOf(search) > -1 && c.isActive == true);
            }
            else
            {
                return this.getCompteGL
            }

        }
    }
}

</script>

<style lang="scss" scoped>
@import "../../../assets/css/components/compteAutoComplete.scss";
@import "../../../assets/css/components/itemListCss.scss";
</style>